import React from 'react';
import type { VertexT } from '../shape/vertex';
import { Vertex } from '../shape/vertex';
import type { BoundingBoxT } from '../utils/scaling-utils';
import { getScaleHandleVertices } from '../utils/scaling-utils';
type ScalingBoundingBoxPropsT = {
  boundingBox: BoundingBoxT;
  isVisible: boolean;
  strokeColor?: string;
  strokeWidth?: number;
  onScaleHandleSelect?: (vertex: VertexT, index: number) => void;
  onScaleHandleDeselect?: (vertex: VertexT, index: number) => void;
};
const getMinX = (bbox: BoundingBoxT): number => bbox.centerX - bbox.width / 2;
const getMinY = (bbox: BoundingBoxT): number => bbox.centerY - bbox.height / 2;
export const ScalingBoundingBox = ({
  boundingBox,
  isVisible,
  strokeColor = '#3b82f6',
  strokeWidth = 2,
  onScaleHandleSelect,
  onScaleHandleDeselect
}: ScalingBoundingBoxPropsT) => {
  if (!isVisible) {
    return null;
  }
  const scaleHandles = getScaleHandleVertices(boundingBox);
  const x = getMinX(boundingBox);
  const y = getMinY(boundingBox);
  return <g data-testid="scaling-bounding-box">
      <rect x={x} y={y} width={boundingBox.width} height={boundingBox.height} fill="none" stroke={strokeColor} strokeWidth={strokeWidth} strokeDasharray="5,5" pointerEvents="none" />
      {scaleHandles.map((vertex, index) => <Vertex key={`scale-handle-${vertex.type}-${index}`} vertex={vertex} onSelect={() => onScaleHandleSelect?.(vertex, index)} onDeselect={() => onScaleHandleDeselect?.(vertex, index)} />)}
    </g>;
};